import React from 'react';

import { Popup, Button } from 'semantic-ui-react';

import PermissionForm from './PermissionForm';

const NewRoleButton = ({ authorized, customRoleExists, onSaveSuccess }) => {
  if (authorized) {
    return (
      <PermissionForm
        trigger={<Button fluid primary content="New Role" disabled={customRoleExists} />}
        onSaveSuccess={onSaveSuccess}
      />
    );
  }

  return (
    <Popup
      content="Your role is not authorized for this action."
      trigger={(
        <Button
          fluid
          primary
          content="New Role"
          style={{
            opacity: 0.5,
            cursor: 'not-allowed',
          }}
        />
      )}
      position="top center"
      hoverable
    />
  );
};

export default NewRoleButton;
